export interface AdminStatsResponse {
  graphs: Graphs;
  farms: {
    count: number;
    next: string;
    previous: string;
    results: AdminStatsFarm[];
  };
}

export interface Graphs {
  sunflower: GraphsData;
  camelina: GraphsData;
}

export interface GraphsData {
  field_status: FieldStatus;
  production: Production;
}

export interface FieldStatus {
  nbr_plots: number;
  total_area: number;
  field_status_number: ValidationStatus;
  field_status_area: ValidationStatus;
}

export interface Production {
  informed_yield: ValidationStatus;
  estimated_yield: ValidationStatus;
  real_yield: ValidationStatus;
  nbr_plots: number;
  total_area: number;
}

export enum FormStatusEnum {
  REJECTED = 'REJECTED',
  FINISHED = 'FINISHED',
  UNDEFINED = 'UNDEFINED',
  ERROR = 'ERROR',
}

type ValidationStatus = {
  [key in FormStatusEnum]: number;
};

export interface AdminStatsFarm {
  id: number;
  last_name: string;
  first_name: string;
  name: string;
  country: string;
  organization: string;
  total_area: number;
  forms1: number;
  forms1_area: number;
  forms2: number;
  forms2_area: number;
  finished_forms: number;
  finished_area: number;
}
